import React, { useState } from "react";

import { FeatureFlag, FeatureFlagsContext } from "./feature-flags-context";

interface FeatureFlagsContextWrapperProps {
  children: React.ReactNode;
}

const FeatureFlagsContextWrapper = ({
  children,
}: FeatureFlagsContextWrapperProps) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlag>({});
  const [isFeatureFlagsLoading, setIsFeatureFlagsLoading] =
    useState<boolean>(false);

  const featureFlagExists = (flagName: string) => {
    return featureFlags.hasOwnProperty(flagName);
  };

  const getFeatureFlagValue = (flagName: string) => {
    // Return early if feature flag does not exist.
    if (!featureFlagExists(flagName)) {
      return undefined;
    }
    return featureFlags[flagName].value.value;
  };

  const featureFlagsContextValue = {
    featureFlags,
    setFeatureFlags,
    isFeatureFlagsLoading,
    setIsFeatureFlagsLoading,
    featureFlagExists,
    getFeatureFlagValue,
  };

  return (
    <FeatureFlagsContext.Provider value={featureFlagsContextValue}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsContextWrapper;
